(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function headerBottom() {
    var bottom = 0;
    document
      .querySelectorAll(
        '.announcement-bar-section, .utility-bar, .section-header, .shopify-section-header-sticky, sticky-header, .header-wrapper'
      )
      .forEach(function (element) {
        var rect = element.getBoundingClientRect();
        if (rect.bottom > bottom && rect.top <= 0) bottom = rect.bottom;
      });
    return Math.max(0, Math.round(bottom));
  }

  function cartIsOpen() {
    var drawer = document.querySelector('cart-drawer');
    return !!(
      drawer &&
      (drawer.classList.contains('active') ||
        drawer.classList.contains('animate') ||
        drawer.getAttribute('aria-hidden') === 'false')
    );
  }

  function mainSubmit(root) {
    return root.querySelector('[data-noirsy-atc-submit]');
  }

  function syncControls(root) {
    var submit = mainSubmit(root);
    if (!submit) return;

    var sourceLabel = submit.querySelector('span');
    var labelText = sourceLabel ? sourceLabel.textContent.trim() : submit.textContent.trim();
    var disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';

    document
      .querySelectorAll('[data-noirsy-sticky-owner="' + root.id + '"] [data-noirsy-sticky-trigger]')
      .forEach(function (button) {
        var label = button.querySelector('[data-noirsy-sticky-label]');
        if (label) label.textContent = labelText;
        button.disabled = disabled;
      });

    var sourcePrice = document.querySelector('.product__info-container .price');
    var destinationPrice = document.querySelector(
      '[data-noirsy-sticky-owner="' + root.id + '"] [data-noirsy-sticky-price]'
    );
    if (sourcePrice && destinationPrice) destinationPrice.innerHTML = sourcePrice.innerHTML;

    var sourceImage = document.querySelector(
      '.product__media-item.is-active img, media-gallery .product__media-item:not([hidden]) img, media-gallery img'
    );
    var destinationImage = document.querySelector(
      '[data-noirsy-sticky-owner="' + root.id + '"] [data-noirsy-sticky-image]'
    );
    if (sourceImage && destinationImage) {
      destinationImage.src = sourceImage.currentSrc || sourceImage.src;
      destinationImage.alt = sourceImage.alt || destinationImage.alt;
    }
  }

  function update(root) {
    var submit = mainSubmit(root);
    var bar = document.querySelector(
      '[data-noirsy-sticky-bar][data-noirsy-sticky-owner="' + root.id + '"]'
    );
    var dock = document.querySelector(
      '[data-noirsy-atc-dock][data-noirsy-sticky-owner="' + root.id + '"]'
    );
    if (!submit || !bar || !dock) return;

    var submitRect = submit.getBoundingClientRect();
    var drawerOpen = cartIsOpen();

    if (isMobile()) {
      bar.hidden = true;
      dock.hidden = drawerOpen || submitRect.bottom > 0;
      document.body.classList.toggle('noirsy-atc-docked', !dock.hidden);
      if (!dock.hidden) {
        document.documentElement.style.setProperty(
          '--noirsy-atc-dock-height',
          dock.offsetHeight + 'px'
        );
      }
    } else {
      dock.hidden = true;
      document.body.classList.remove('noirsy-atc-docked');
      document.documentElement.style.removeProperty('--noirsy-atc-dock-height');
      document.documentElement.style.setProperty('--noirsy-sticky-top', headerBottom() + 'px');
      bar.hidden = drawerOpen || submitRect.bottom >= headerBottom() - 8;
    }
  }

  function mount(root) {
    if (!root.id || root.dataset.noirsyStickyInit === '1') return;
    root.dataset.noirsyStickyInit = '1';

    var submit = mainSubmit(root);
    var bar = root.querySelector('[data-noirsy-sticky-bar]');
    var dock = root.querySelector('[data-noirsy-atc-dock]');
    if (!submit || !bar || !dock) return;

    [bar, dock].forEach(function (element) {
      element.dataset.noirsyStickyOwner = root.id;
      document.body.appendChild(element);
    });

    document
      .querySelectorAll('[data-noirsy-sticky-owner="' + root.id + '"] [data-noirsy-sticky-trigger]')
      .forEach(function (button) {
        button.addEventListener('click', function () {
          if (!button.disabled) submit.click();
        });
      });

    if (window.MutationObserver) {
      new MutationObserver(function () {
        syncControls(root);
        update(root);
      }).observe(submit, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
        childList: true,
        subtree: true,
        characterData: true,
      });

      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        new MutationObserver(function () {
          update(root);
        }).observe(drawer, {
          attributes: true,
          attributeFilter: ['class', 'aria-hidden'],
        });
      }
    }

    var refresh = function () {
      syncControls(root);
      update(root);
    };
    window.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });
    document.addEventListener('variant:change', refresh);

    refresh();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-noirsy-atc]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
